import { render, staticRenderFns } from "./NewWebCallPage.vue?vue&type=template&id=a0294390&scoped=true&"
import script from "./NewWebCallPage.vue?vue&type=script&lang=js&"
export * from "./NewWebCallPage.vue?vue&type=script&lang=js&"
import style0 from "./NewWebCallPage.vue?vue&type=style&index=0&id=a0294390&lang=scss&scoped=true&"
import style1 from "./NewWebCallPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0294390",
  null
  
)

export default component.exports